import { render } from "./OrderPrintFormComponent.vue?vue&type=template&id=54a95347&scoped=true&ts=true"
import script from "./OrderPrintFormComponent.vue?vue&type=script&lang=ts"
export * from "./OrderPrintFormComponent.vue?vue&type=script&lang=ts"

import "./OrderPrintFormComponent.vue?vue&type=style&index=0&id=54a95347&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54a95347"]])

export default __exports__